import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loader: false,
    isLoggedIn: false,
    user: null,
    otpError: null,
    error: null
}

const userReducer = createSlice({
    name: "user",
    initialState,
    reducers: {
        initLogin: (state) =>  {
            state.loader = true
        },
        loginSuccess: (state, action) => {
            state.user = action.payload.data
            state.isLoggedIn = !!action.payload.token
            state.error = null
            state.loader = false
            state.error = null
        },
        loginFailure: (state, action) => {
            state.user = null
            state.isLoggedIn = false
            state.loader = false
            state.error = action.payload
        },
        logout: state => {
            state.loader = true
        },
        logoutSuccess: state => {
            state.user = null
            state.loader = false
            state.isLoggedIn = false
        },
        otpFailure: (state, action) => {
            state.loader = false
            state.otpError = action.payload
        },
        setUser: (state, action) => {
            state.user = action.payload
        },
        logoutFailure: state => {
            state.loader = false
        },
    },
})

export const {
    loginSuccess,
    logoutFailure,
    loginFailure,
    logout,
    otpFailure,    
    logoutSuccess,
    initLogin,
    setUser
} = userReducer.actions

export default userReducer.reducer
